import React, { useEffect, useState } from "react";

function useFiltersHook(indValues, depValues, search, priceRange, orderBy, currentPage, catId) {
  const [filters, setFilters] = useState([]);
  const configureFilters = () => {
    const filterIndDpendentFilters =
      indValues &&
      Object.keys(indValues).reduce((acc, category) => {
        const filteredCategory = indValues[category]?.values?.filter((item) => item.isChecked);
        if (filteredCategory?.length > 0) {
          acc[category] = filteredCategory;
        }
        return acc;
      }, {});

    const filterDpendentFilters =
      depValues &&
      Object.keys(depValues).reduce((acc, category) => {
        const filteredCategory = depValues[category]?.values?.filter((item) => item.isChecked);
        if (filteredCategory?.length > 0) {
          acc[category] = filteredCategory;
        }
        return acc;
      }, {});

    const newFilter = {
      ...(search && { title: search }),
      ...(priceRange && Object.keys(priceRange).length > 0 && { price: priceRange }),
      ...(Object.keys(orderBy).length > 0 && { orderBy: orderBy }),
      ...(currentPage && { currentPage: currentPage }),
      ...(filterDpendentFilters &&
        catId && {
          filterDpendentFilters: filterDpendentFilters,
        }),
      ...(filterIndDpendentFilters && {
        filterIndDpendentFilters: filterIndDpendentFilters,
      }),
    };
    setFilters(newFilter);
    // setFiltersData(filtersData)
  };

  useEffect(() => {
    configureFilters();
  }, [depValues, indValues, search, priceRange, orderBy, currentPage, catId]);

  return filters;
}

export default useFiltersHook;
